/**
 * Tenant Create-Agent chooser route — thin wrapper around
 * <AgentNew scope="tenant">.
 *
 * PR-B agent-new shared-component refactor (2026-05-12).
 * The entire chooser body lives in
 * `@/components/agent-new-shared/AgentNew.tsx`. This file only declares
 * the TanStack-Router file route. ALL mode-selector, Quick Create form,
 * and Import-JSON logic is shared with the sysadmin chooser route.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AgentNew } from '@/components/agent-new-shared/AgentNew';

export const Route = createFileRoute('/agents/new')({
  component: CreateAgentPage,
});

function CreateAgentPage() {
  return <AgentNew scope="tenant" />;
}
